module.exports = __webpack_public_path__ + "static/media/weight.798aeb18.svg";